import { BG_IMAGES } from '@/config/bg';
import NavbarInstitut from '../../../components/feature/NavbarInstitut';
import FooterInstitut from '@/components/feature/FooterInstitut';

export default function InstitutLicencePage() {
  return (
    <div className="min-h-screen bg-white">
      <NavbarInstitut />

      {/* Header avec bannière */}
      <div className="relative mb-12">
        <div
          className="relative h-64 pt-24 sm:h-96 overflow-hidden bg-cover bg-center"
          style={{ backgroundImage: `url(${BG_IMAGES.institut})` }}
          data-aos="fade-up"
        >
          <div className="absolute inset-0 bg-black/40"></div>
          <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-2 text-white" style={{ fontFamily: 'Playfair Display, serif' }}>
              LICENCE — INSTITUT UNIVERSITAIRE FRED & POPPEE
            </h1>
            <p className="text-lg text-white/90 max-w-3xl mx-auto">Formations universitaires de premier cycle dans les domaines du droit, de l'informatique et des sciences économiques</p>
          </div>
        </div>
      </div>

      {/* Contenu principal */}
      <div className="pt-8 pb-20 px-5">
        <div className="max-w-7xl mx-auto">
          {/* Introduction */}
          <div className="mb-12 text-center" data-aos="fade-up">
            <p className="text-gray-700 text-lg max-w-3xl mx-auto">
              Notre programme de Licence offre une formation académique rigoureuse et complète, 
              préparant les étudiants à des carrières professionnelles enrichissantes et à la poursuite d'études supérieures.
            </p>
          </div>

          {/* Grille des départements */}
          <div className="grid gap-8 md:grid-cols-3 mb-16">
            {/* Sciences Juridiques */}
            <article className="bg-white rounded-xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow" data-aos="fade-up">
              <div className="flex flex-col h-full">
                <div className="flex items-start gap-4 mb-6">
                  <div className="flex-shrink-0">
                    <div className="w-14 h-14 rounded-lg bg-blue-50 flex items-center justify-center text-blue-600">
                      <i className="ri-scales-3-line text-2xl"></i>
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-gray-900">Sciences Juridiques</h3>
                    <p className="text-gray-600 text-sm mt-1">Administratives et Politiques</p>
                  </div>
                </div>
                <p className="text-gray-700 mb-6 flex-grow">
                  Formation complète en droit civil, pénal, administratif et constitutionnel. Développement de compétences 
                  juridiques pointues et compréhension approfondie des principes fondamentaux du système légal.
                </p>
                <div className="space-y-4">
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Compétences acquises</h4>
                    <ul className="text-gray-700 space-y-1">
                      <li className="flex items-center gap-2">
                        <i className="ri-check-line text-green-600"></i>
                        Analyse juridique et rédaction d'actes
                      </li>
                      <li className="flex items-center gap-2">
                        <i className="ri-check-line text-green-600"></i>
                        Procédures judiciaires et administratives
                      </li>
                      <li className="flex items-center gap-2">
                        <i className="ri-check-line text-green-600"></i>
                        Négociation et médiation
                      </li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Débouchés</h4>
                    <div className="flex flex-wrap gap-2">
                      <span className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-sm">Avocat</span>
                      <span className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-sm">Juriste d'entreprise</span>
                      <span className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-sm">Magistrat</span>
                    </div>
                  </div>
                </div>
              </div>
            </article>

            {/* Sciences Informatiques */}
            <article className="bg-white rounded-xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow" data-aos="fade-up" data-aos-delay="100">
              <div className="flex flex-col h-full">
                <div className="flex items-start gap-4 mb-6">
                  <div className="flex-shrink-0">
                    <div className="w-14 h-14 rounded-lg bg-purple-50 flex items-center justify-center text-purple-600">
                      <i className="ri-computer-line text-2xl"></i>
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-gray-900">Sciences de l'Informatique</h3>
                    <p className="text-gray-600 text-sm mt-1">Programmation et Technologies Numériques</p>
                  </div>
                </div>
                <p className="text-gray-700 mb-6 flex-grow">
                  Formation théorique et pratique intensive en programmation, bases de données, réseaux et intelligence artificielle. 
                  Approche moderne basée sur les technologies actuelles et méthodologies de développement.
                </p>
                <div className="space-y-4">
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Compétences acquises</h4>
                    <ul className="text-gray-700 space-y-1">
                      <li className="flex items-center gap-2">
                        <i className="ri-check-line text-green-600"></i>
                        Développement web et mobile
                      </li>
                      <li className="flex items-center gap-2">
                        <i className="ri-check-line text-green-600"></i>
                        Conception de systèmes et bases de données
                      </li>
                      <li className="flex items-center gap-2">
                        <i className="ri-check-line text-green-600"></i>
                        Intelligence artificielle et data science
                      </li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Débouchés</h4>
                    <div className="flex flex-wrap gap-2">
                      <span className="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-sm">Développeur Web</span>
                      <span className="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-sm">Analyste Programmeur</span>
                      <span className="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-sm">Consultant IT</span>
                    </div>
                  </div>
                </div>
              </div>
            </article>

            {/* Sciences Économiques */}
            <article className="bg-white rounded-xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow" data-aos="fade-up" data-aos-delay="200">
              <div className="flex flex-col h-full">
                <div className="flex items-start gap-4 mb-6">
                  <div className="flex-shrink-0">
                    <div className="w-14 h-14 rounded-lg bg-green-50 flex items-center justify-center text-green-600">
                      <i className="ri-line-chart-line text-2xl"></i>
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-gray-900">Sciences Économiques</h3>
                    <p className="text-gray-600 text-sm mt-1">Gestion, Finance et Marketing</p>
                  </div>
                </div>
                <p className="text-gray-700 mb-6 flex-grow">
                  Formation complète en économie, gestion d'entreprise, finance, comptabilité et marketing digital. 
                  Développement de compétences analytiques pointues pour comprendre les mécanismes économiques modernes.
                </p>
                <div className="space-y-4">
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Compétences acquises</h4>
                    <ul className="text-gray-700 space-y-1">
                      <li className="flex items-center gap-2">
                        <i className="ri-check-line text-green-600"></i>
                        Analyse économique et financière
                      </li>
                      <li className="flex items-center gap-2">
                        <i className="ri-check-line text-green-600"></i>
                        Gestion comptable et audit
                      </li>
                      <li className="flex items-center gap-2">
                        <i className="ri-check-line text-green-600"></i>
                        Stratégies marketing digital
                      </li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Débouchés</h4>
                    <div className="flex flex-wrap gap-2">
                      <span className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm">Analyste Financier</span>
                      <span className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm">Expert-Comptable</span>
                      <span className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm">Marketing Digital</span>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </div>

          {/* Section supplémentaires */}
          <div className="grid gap-8 md:grid-cols-2" data-aos="fade-up">
            {/* Modalités d'admission */}
            <div className="bg-gray-50 rounded-xl p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Modalités d'admission</h3>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-green-600 text-xl mt-1"></i>
                  <span className="text-gray-700">Baccalauréat ou diplôme équivalent</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-green-600 text-xl mt-1"></i>
                  <span className="text-gray-700">Dossier académique complet</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-green-600 text-xl mt-1"></i>
                  <span className="text-gray-700">Entretien de motivation</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-green-600 text-xl mt-1"></i>
                  <span className="text-gray-700">Rentrée : Octobre 2025</span>
                </li>
              </ul>
              <div className="mt-8">
                {/* <a
                  href="#"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition-colors"
                >
                  <i className="ri-calendar-line"></i>
                  Postuler maintenant
                </a> */}
              </div>
            </div>

            {/* Vie étudiante */}
            <div className="bg-gray-50 rounded-xl p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Vie étudiante et activités</h3>
              <div className="space-y-6">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-lg bg-orange-50 flex items-center justify-center text-orange-600">
                    <i className="ri-team-line text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Association Sportive</h4>
                    <p className="text-gray-700">Football, Basketball et autres activités sportives</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-lg bg-red-50 flex items-center justify-center text-red-600">
                    <i className="ri-bus-line text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Activités extrascolaires</h4>
                    <p className="text-gray-700">Sorties culturelles, excursions et événements académiques</p>
                  </div>
                </div>
              </div>
              <div className="mt-8">
                {/* <p className="text-gray-700">
                  <i className="ri-information-line text-blue-600"></i>
                  Téléchargez notre brochure complète pour plus d'informations sur les programmes et la vie sur le campus.
                </p>
                <a
                  href="#"
                  className="inline-flex items-center gap-2 px-6 py-3 border border-blue-600 text-blue-600 rounded-lg font-semibold hover:bg-blue-50 transition-colors mt-4"
                >
                  <i className="ri-download-line"></i>
                  Télécharger la brochure
                </a> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <FooterInstitut />
    </div>
  );
}